import { AppState } from '@fcom/core';
import { FinnairOrder, TourOperatorCode, Category } from '@fcom/dapi/api/models';
import { DapiErrorStatus, IdAndHash, ServicesState } from '@fcom/dapi/interfaces';
import { SeatMapState } from '@fcom/common/interfaces/seat-map.interface';

import { PaymentState } from '../interfaces';
import { COMMON_BOOKING_FEATURE_KEY } from './constants';

export interface PassengerNameRecord {
  recLoc: string;
  lastName?: string;
  firstName?: string;
  tourOperatorCode?: TourOperatorCode | undefined;
}

export enum OrderStatus {
  /** The order has not been initialized */
  INITIAL,

  /** The order is created, but is waiting for data to be refreshed from server */
  PENDING,

  /** The order failed to load from the given location */
  LOAD_ERROR,

  /** The order has been created and is ok */
  OK,
}

export enum OrderPartStatus {
  OK,
  UPDATING,
  ERROR,
}
export type UpdatingOrderPart = Record<string, OrderPartStatus>;
export type CategoryStatusMap = Partial<Record<Category, OrderPartStatus>>;

export interface OrderState {
  /** The current status of the order. */
  orderStatus: OrderStatus;

  /** This is the actual order data from the `GET ${orderUrl}` response. */
  orderData?: FinnairOrder;

  /** Error response status */
  orderResponseErrorStatus?: DapiErrorStatus;

  orderFetchInformation?: IdAndHash;

  isUpdating?: UpdatingOrderPart;

  PNR?: PassengerNameRecord;

  acceptTerms?: boolean;

  /**
   * Used to flag when a user is clicking a review and pay flow email link after already
   * successfully paying for the order. In this case we do not want to send analytics events again
   */
  analyticsSent?: boolean;
}

export interface DisruptionState {
  selectedBoundId?: string;
}

export interface RedirectState {
  pnr: PassengerNameRecord;
}

export interface CommonBookingState {
  services?: ServicesState;
  order?: OrderState;
  seatMap?: SeatMapState;
  seatsDirty?: boolean;
  payment?: PaymentState;
  disruption?: DisruptionState;
  redirect?: RedirectState;
}

export interface CommonBookingFeatureState extends AppState {
  readonly [COMMON_BOOKING_FEATURE_KEY]: CommonBookingState;
}

export type QuantityForFragmentAndPassenger = Record<string, Record<string, number>>;
